import { post, patch, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR, { mutate } from 'swr'
import { handleApiResponse } from './api_util';

async function pingPrimaryDatabaseStatus() {
  const payload = {
    apiName: 'LivisiblyDatabaseCheckApi',
    path: 'primary/ping'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  const result = processResponse(response)
  return result
}

async function pingCaseDatabaseStatus(caseId) {
  const payload = {
    apiName: 'LivisiblyDatabaseCheckApi',
    path: `casedb/ping/case/${caseId}`

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  const result = processResponse(response)
  return result
}

async function getAndStartPrimaryDatabaseStatus() {

  const payload = {
    apiName: 'LivisiblyDatabaseCheckApi',
    path: 'primary/check_start'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  const result = processResponse(response)
  return result
}

// A healthy check_start/ping response is the string "<Response [200]>". Once we
// see it there is nothing left to poll for, so we drop the refresh interval to 0
// (stop) — otherwise the hook keeps hammering the endpoint for the life of the
// mounted page. Until then we retry on a sane 5s cadence.
// NOTE: these intervals were previously `5` (FIVE MILLISECONDS, not seconds) —
// SWR's refreshInterval is in ms, so that polled as fast as round-trips completed
// and starved the real data fetches (case_stats) of the connection. Keep these in
// milliseconds.
const DB_STATUS_POLL_MS = 5000;

function dbUpRefreshInterval(latest) {
  // latest?.status is "<Response [200]>" when the DB responded OK; stop polling.
  return latest && latest.status === "<Response [200]>" ? 0 : DB_STATUS_POLL_MS;
}

// Shared "is the case DB actually ready to serve real queries" check, so
// every consumer (CaseDatabaseCheck's render gate, EnrichedTransactionPreloader's
// fetch gate) agrees on the same signal instead of re-deriving it. `status` is
// the literal string "<Response [200]>" once check_start/ping succeeds; while
// waking it's an { status_code: 'unreachable', error } object, or undefined
// while the request itself is in flight.
export function isCaseDbReady(status) {
  return status === "<Response [200]>";
}

export function usePingPrimaryDatabaseStatus(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? 'PRIMARY_DATABASE_STATUS_PING' : null,
    (path) => pingPrimaryDatabaseStatus(),
    {refreshInterval: DB_STATUS_POLL_MS}
  );

  return result;
}

export function usePingCaseDatabaseStatus(caseId, shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? ['CASE_DATABASE_STATUS_PING', caseId] : null,
    (path) => pingCaseDatabaseStatus(caseId),
    {refreshInterval: DB_STATUS_POLL_MS}
  );

  return result;
}

export function useGetAndStartPrimaryDatabaseStatus(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? 'PRIMARY_DATABASE_STATUS_START' : null,
    (path) => getAndStartPrimaryDatabaseStatus(),
    {refreshInterval: dbUpRefreshInterval}
  );

  return result;
}


async function getAndStartCaseDatabaseStatus() {

  const payload = {
    apiName: 'LivisiblyDatabaseCheckApi',
    path: 'casedb/check_start'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  const result = processResponse(response)
  return result
}


export function useGetAndStartCaseDatabaseStatus(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? 'CASE_DATABASE_STATUS_START' : null,
    (path) => getAndStartCaseDatabaseStatus(),
    {refreshInterval: dbUpRefreshInterval}
  );

  return result;
}



async function getCaseDatabaseVersion(){
  const payload = {
    apiName: 'LivisiblyDatabaseCheckApi',
    path: 'casedb/version'

  }

  const restOperation = get(payload);
  const response = await restOperation.response;

  const result = processResponse(response)
  return result
}

export function useGetCaseDatabaseVersion(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? 'CASE_DATABASE_VERSION' : null,
    (path) => getCaseDatabaseVersion(),
    {
      // Poll every 5s while the version is unknown/stale, but stop once we've
      // confirmed the DB is on the current version — the answer won't change
      // under a mounted page, so continuing to poll is pure waste.
      refreshInterval: (latest) => (latest && latest.is_current_version ? 0 : 5000),
      shouldRetryOnError: true,  // Keep retrying on error
      errorRetryInterval: 5000,  // Retry every 5 seconds
      errorRetryCount: undefined,  // Retry indefinitely
    }
  );
  return result;
}

export async function migrateCaseDatabase(){
  const payload = {
    apiName: 'LivisiblyCaseDataMigrationApi',
    path: 'case_migration'
  }
  const restOperation = post(payload);
  const response = await restOperation.response;
  const result = processResponse(response)
  return result
}

